import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetTeacherAnswerQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import VideoJS from '../../components/VideoJs';

const TeacherWatchAnswer = () => {

    const navigate = useNavigate();
    const playerRef = useRef(null);

    const { id } = useParams();

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, isLoading, error } = useGetTeacherAnswerQuery(id);

    const [isvideo, setIsvideo] = useState(true); 

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])  

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
          src: `https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/asnwers/${data?.mediaId}`,
          type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on('waiting', () => {});
        player.on('dispose', () => {});
    };

  return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br />      
            <div className="container-fluid mt--6">
                {isLoading ? ( 
                    <Loader />
                ) : error ? (
                    <Message variant='danger'>
                        {error?.data?.message || error.error}
                    </Message>
                ) : (
                    <div className="row">
                        <div className="col-xl-10 offset-xl-1">   
                            <div className="card mycard">
                                <h3 className="tittleColor videoTitle">
                                    <span className='tittleColor' style={{textTransform: 'capitalize'}}>
                                        {data?.subjectname}    
                                    </span>
                                </h3>
                                {isvideo  ?                                                                      
                                <VideoJS 
                                    options={videoJsOptions} 
                                    onReady={handlePlayerReady} 
                                    cssRule="card-img-top"
                                />                        
                                :
                                <div className="card-body "><br /><br /><br />
                                            <h4 className='tittleColor4'>
                                                <span className='tittleColor22'> Video is processing  </span> <br  />
                                                <span className='tittleColor4'> &nbsp; &nbsp; &nbsp; Please check a few minutes later ... </span> <br  />
                                                <img src='../../assets/img/loading.gif' alt='loading' className='loadingVid' /> 
                                                <br /><br /><br /><br />
                                            </h4> 
                                        </div>
                                }
                                <div className="card-body ">
                                    <h4 className="h4 card-title4 mb-0 mycard">
                                    <span className='tittleColor'>{data?.tittle}</span></h4>
                                    <p className="text-muted ">{data?.description}</p>                                    
                                    <LinkContainer to={`/teacherpreviousanswers/${data?.subject}`} className='btn btn-default '>
                                    <Button variant="primary  bg-gradient-info"> Go to  Question</Button>
                                    </LinkContainer>
                                    <br /><br /><br />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>        
        </div>      
    </div>
  )
}

export default TeacherWatchAnswer
